module.exports = __webpack_public_path__ + "img/icon-button-write.0c5356ee.svg";